import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

export default function Home(props) {
	return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      <Typography sx={{fontWeight: "bold"}}>
        Welcome to the Vermont Drought Dashboard! 
      </Typography>
      <Typography sx={{mt:2}}>
        "Vermont continues to be susceptible to both flooding and droughts occurring in the same year.
        Prolonged drought conditions were observed in 1930-1936, 1939-1943, 1960-1969, 1980-1981, 
        1988-1989, 1991, 1995, 1998-1999, 2006-2007, 2010, 2011, 2012, 2016-2017, 2018, and 2020-2021. 
        During the extreme hydrologic drought of 2020-2021, new 30-year record lows were observed across 
        the state" - from <Link href="https://statesummaries.ncics.org/chapter/vt/" target='_blank' rel='nopener noreferer'>
        State Climate Summaries 2022, Vermont</Link>. The 2025 flash drought was historic 
        in terms of the rapidity with which conditions deteriorated, the extent and severity of the impacts
        observed across all economic sectors and the human suffering that was endured.
      </Typography>
      <Typography sx={{mt:2}}>
        The Vermont Drought Dashboard was developed to provide a one-stop-shop for timely, relevant drought data, tools and monitoring information.
        Resources featured in this dashboard are updated in real-time, ensuring that only 
        the most up-to-date information is displayed. Resources are grouped by socioeconomic sector and can be accessed through 
        the navigation menu to the left.
      </Typography>
      <Typography sx={{mt:2}}>
        The Vermont Drought Dashboard was developed by the&nbsp;
        <a href="https://www.nrcc.cornell.edu/" target="_blank" rel="noopener noreferrer">
        Northeast Regional Climate Center</a>, 
        in collaboration with the Vermont State Climatologist at the University of Vermont, to 
        better provide ongoing access and awareness to Vermonters about droughts. 
        The Dashboard supports the activities of the Vermont Drought Task Force, an 
        interagency group, with representatives from a range of state, federal and partner organizations. 
        When activated, the Task Force meets regularly to monitor drought conditions, increase 
        awareness about these conditions, and develop recommendations for response. Funding 
        for this project (<a href="https://www.drought.gov/drought-research/developing-tailored-drought-monitoring-products-state-vermont/" 
        target="_blank" rel="noopener noreferrer">Developing Tailored Drought Monitoring Products for the State of Vermont</a>) was provided by NOAA's National Integrated Drought Information System (
        <a href="https://drought.gov/" target="_blank" rel="noopener noreferrer">NIDIS</a>) (<a href="https://www.drought.gov/states/vermont/" target="_blank" rel="noopener noreferrer">NIDIS Vermont Drought Page</a>).
      </Typography>

      <footer style={{ width: '100%', position:'absolute', bottom: 98  }}>
        <Grid container spacing={2}>
          <Grid size={4}>
            <Link href="https://drought.gov" target="_blank" rel="noopener">
              <Box
                component='img'
                src={`${process.env.PUBLIC_URL}/images/noaa-nidis-logo.png`}
                alt="NIDIS https://drought.gov"
                sx={{
                  height: '65px',
                  maxWidth: '100%',
                  display: 'block',
                  margin: '0 auto',
                }}
              />
            </Link>
          </Grid>
          <Grid size={4}>
            <Link href="https://www.nrcc.cornell.edu" target="_blank" rel="noopener">
              <Box
                component='img'
                src={`${process.env.PUBLIC_URL}/images/nrccLogoStackedT.png`}
                alt="Northeast Regional Climate Center https://www.nrcc.cornell.edu"
                sx={{
                  height: '65px',
                  maxWidth: '100%',
                  display: 'block',
                  margin: '0 auto',
                }}
              />
            </Link>
          </Grid>
          <Grid size={4}>
            <Link href="https://www.uvm.edu/" target="_blank" rel="noopener">
              <Box
                component='img'
                src={`${process.env.PUBLIC_URL}/images/UVM_Logo_Primary_Horiz_G.png`}
                alt="University of Vermont https://www.uvm.edu/"
                sx={{
                  py: '10px',
                  height: '65px',
                  maxWidth: '100%',
                  display: 'block',
                  margin: '0 auto',
                }}
              />
            </Link>
          </Grid>
        </Grid>
      </footer>
    </div>
  )
}